exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.layout > .flex[data-v-71445aaf] {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.hidden[data-v-71445aaf] {\n  display: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-71445aaf","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/botbuilder/openAIConfig.vue
// module id = X+CD
// module chunks = 1